import React from 'react'
import parser from 'html-react-parser'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

export default function Donation4({ data }) {
    const { donation4ButtonText, donation4Text, donation4ButtonLink, donation4Title, donation4ButtonExternalLink } = data
    return (
        <div className='donate-today-wrap font-white'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-6'>
                        <h2 className='heading-level-2-i text-uppercase white-color'>
                            {donation4Title && parser(donation4Title)}
                        </h2>
                        <p>{donation4Text && parser(donation4Text)}</p>
                        {donation4ButtonExternalLink ? (
                            <a href={donation4ButtonExternalLink} className="btn white-btn">
                                {donation4ButtonText}
                            </a>
                        ) : donation4ButtonLink ? (
                            <Link
                                to={donation4ButtonLink.uri}
                                className='btn white-btn'
                            >
                                {donation4ButtonText}
                            </Link>
                        ) : null}
                    </div>
                    <div className='col-md-6'>
                        <div className='donate-image-sec'>
                            <StaticImage
                                src='../../../images/donate-image.png'
                                alt='image'
                            />
                        </div>
                        <div className='donate-image-sec-1'>
                            <StaticImage
                                src='../../../images/donate-image.png'
                                alt='image'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
